import React from "react";
import { IMAGES } from "../data/site";

export default function PageHero({ eyebrow, title, intro, image = "govBuilding", testid }) {
  return (
    <section
      className="relative bg-[#0A1F35] text-white overflow-hidden"
      data-testid={testid || "page-hero"}
    >
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage: `url(${IMAGES[image] || IMAGES.govBuilding})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,31,53,0.85) 0%, rgba(10,31,53,0.96) 100%)",
        }}
        aria-hidden="true"
      />
      <div className="relative container-x py-20 sm:py-24 lg:py-28">
        <div className="max-w-3xl">
          {eyebrow && (
            <p className="text-overline text-[#9BB7A2] mb-5 reveal">{eyebrow}</p>
          )}
          <h1 className="heading-hero text-4xl sm:text-5xl lg:text-6xl mb-6 reveal reveal-delay-1">
            {title}
          </h1>
          {intro && (
            <p className="text-lg sm:text-xl text-white/80 leading-relaxed max-w-2xl reveal reveal-delay-2">
              {intro}
            </p>
          )}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/25 to-transparent" />
    </section>
  );
}
